import React from 'react'
import styles from './style'
import propTypes from './prop'
import { withStyles } from '@material-ui/core'
import { CoreTextField } from 'src/components/core'
/**
 *
 * @param {*} props
 */
const Signup = () => {
  return (
    <CoreTextField
      placeholder="Users enter their e-mail address."
      disabled
      fullWidth
    />
  )
}

Signup.propTypes = propTypes

export default withStyles(styles)(Signup)
